$('document').ready(() => {
    const sliders = document.querySelectorAll('.bestseller-slider');

    sliders.forEach(slider => {
        const isTriple = slider.classList.contains('js-slider-triple');
        const isDouble = slider.classList.contains('js-slider-double');
        const isComparison = slider.classList.contains('js-comparison-slider');

        const settingsSlider = {
            spaceBetween: 24,
            navigation: {
                nextEl: '.bestseller-slider__nav--next',
                prevEl: '.bestseller-slider__nav--prev',
            },
            scrollbar: {
                el: '.bestseller-slider__scrollbar',
                hide: false,
                draggable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },

                1024: {
                    slidesPerView: 4,
                }
            }
        }

        if (isDouble) {
            settingsSlider.slidesPerView = 2;
            settingsSlider.spaceBetween = 8;
            settingsSlider.breakpoints = {
                768: {
                    spaceBetween: 24,
                },
            }
        }

        if (isTriple) {
            settingsSlider.breakpoints = {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            }
        }

        if (isComparison) {
            settingsSlider.slidesPerView = 2;
            settingsSlider.spaceBetween = 12;
            settingsSlider.breakpoints = {
                1024: {
                    slidesPerView: 4,
                },
            }
        }

        const config = new Swiper(slider, settingsSlider);

        if (isComparison) {
            const diffInput = document.querySelector(`input[name="differences"]`);

            config.on('transitionStart', (swiper) => {
                const item = swiper.el.closest('[data-comparison]');
                const stats = item.querySelector('.js-comparison-characteristics');

                stats.style.opacity = 0;
            })

            config.on('transitionEnd', (swiper) => {
                const item = swiper.el.closest('[data-comparison]');
                const scrollBoxes = item.querySelectorAll('.js-comparison-scroll-box');
                const stats = item.querySelector('.js-comparison-characteristics');

                const isDiff = diffInput.checked;

                const activeIndex = swiper.activeIndex;

                scrollBoxes.forEach(box => {
                    const divWidth = box.children[0].offsetWidth;
                    const oneEl = box.children[activeIndex];
                    const twoEl = box.children[activeIndex + 1];

                    if (isDiff && oneEl.innerHTML === twoEl.innerHTML) {
                        box.parentElement.classList.add('_hide');
                    } else if (oneEl.innerHTML === '–' && twoEl.innerHTML === '–') {
                        box.parentElement.classList.add('_hide');
                    } else {
                        box.parentElement.classList.remove('_hide');
                    }

                    box.scrollLeft = activeIndex * (divWidth + 8);
                })

                checkHiddenStats(item);

                stats.style.opacity = 1;
            })

            function checkHiddenStats(container) {
                const contents = container.querySelectorAll('.js-dropdown');

                contents.forEach(item => {
                    const stats = item.querySelectorAll('.lk__comparison-characteristic');
                    const statsHide = item.querySelectorAll('.lk__comparison-characteristic._hide');

                    if (stats.length === statsHide.length) {
                        item.classList.add('_hide');
                    } else {
                        item.classList.remove('_hide');
                    }
                })

                const showingContents = Array.from(contents).filter(item => !item.classList.contains('_hide'));

                if (showingContents.length === 1) {
                    showingContents[0].classList.add('_show');
                } else {
                    showingContents.forEach(item => item.classList.remove('_show'));
                }
            }
        }
    })
})
